import { render, staticRenderFns } from "./InvalidFormTitle.vue?vue&type=template&id=10a46f34&scoped=true&"
import script from "./InvalidFormTitle.vue?vue&type=script&lang=js&"
export * from "./InvalidFormTitle.vue?vue&type=script&lang=js&"
import style0 from "./InvalidFormTitle.vue?vue&type=style&index=0&id=10a46f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a46f34",
  null
  
)

export default component.exports